import { render, staticRenderFns } from "./CompanyEntitlements.vue?vue&type=template&id=54b55a69&scoped=true"
import script from "./CompanyEntitlements.vue?vue&type=script&lang=js"
export * from "./CompanyEntitlements.vue?vue&type=script&lang=js"
import style0 from "./CompanyEntitlements.vue?vue&type=style&index=0&id=54b55a69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b55a69",
  null
  
)

export default component.exports